var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-trending-up",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.5 15L76.0875 23.5875L57.7875 41.8875L42.7875 26.8875L15 54.7125L20.2875 60L42.7875 37.5L57.7875 52.5L81.4125 28.9125L90 37.5V15H67.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3Icon);
export default __webpack_public_path__ + "static/media/card-3-icon.4095717bcce18287d022bbc48cf51733.svg";
export { ForwardRef as ReactComponent };